<kc-dialog>
  <ng-template #titleTemplate>{{ title() }}</ng-template>
  <ng-template #contentTemplate>
    <div class="ladder-review">
      <div class="ladder-review__stats">
        <div>
          <span>Orders</span>
          <strong>x {{ remainingCount() }}</strong>
        </div>
        <div>
          <span>Step</span>
          <strong>{{ stepLabel() }}</strong>
        </div>
        <div>
          <span>Each amount</span>
          <strong>{{ data.tokenAmount }} {{ data.ticker }}</strong>
        </div>
        <div>
          <span>Total value</span>
          <strong>{{ formatSompi(remainingNotionalSompi()) }}</strong>
        </div>
      </div>

      <p class="ladder-review__hint">
        Review each resting limit before queueing. The first order uses the
        ticket price; later orders move by the step. Confirm adds them to the
        wallet task queue the same way repeated Buy/Sell clicks would.
      </p>

      <ol class="ladder-review__list">
        @for (row of rows(); track row.id; let i = $index) {
          <li>
            <span class="ladder-review__idx">#{{ i + 1 }}</span>
            <span class="ladder-review__amt"
              >{{ data.tokenAmount }} {{ data.ticker }}</span
            >
            <span class="ladder-review__price">{{
              formatSompi(row.unitPriceSompi)
            }}</span>
            <span class="ladder-review__value">{{
              formatSompi(row.notionalSompi)
            }}</span>
            <kc-icon-button
              icon="close"
              size="xs"
              variant="secondary"
              ariaLabel="Remove order"
              (buttonClick)="removeRow(row.id)"
            />
          </li>
        }
      </ol>

      @if (!remainingCount()) {
        <p class="ladder-review__empty">No orders left to queue.</p>
      }

      <div class="ladder-review__actions">
        <kc-button
          variant="secondary"
          size="m"
          text="Cancel"
          [isFullWidth]="true"
          (buttonClick)="close()"
        />
        <kc-button
          variant="primary"
          size="m"
          [text]="confirmLabel()"
          [isFullWidth]="true"
          [isDisabled]="remainingCount() < 1"
          (buttonClick)="confirm()"
        />
      </div>
    </div>
  </ng-template>
</kc-dialog>
